module.exports = __webpack_public_path__ + "media/images/emblems/Pompaples-coat_of_arms-566e7d23de015e863e0dd3d9e4a0f102.svg";